import { Organization } from "../../organizations/models/organizations.entity";
import { Talker } from "../../users/models/talker.entity";

function isManagedPlan(organization?: Organization | null, planCode?: string): boolean {
  return organization?.activeSubscription?.planCode === planCode;
}

export function talkerCanAccessFormations(talker?: Talker | null): boolean {
  if (!talker) {
    return false;
  }

  const capability = talker.organization?.capabilities?.formations;
  if (capability !== undefined) {
    return capability;
  }

  if (isManagedPlan(talker.organization, "wetalk")) {
    return false;
  }

  return talker.organization?.subscriptionPlan?.slug !== "wetalk";
}

export function talkerCanAccessResources(talker?: Talker | null): boolean {
  if (!talker) {
    return false;
  }

  const capability = talker.organization?.capabilities?.resources;
  if (capability === "none") {
    return false;
  }
  if (capability === "linked_only") {
    return !!talker.trainMemberships?.length;
  }
  if (capability === "full") {
    return true;
  }

  if (isManagedPlan(talker.organization, "wetalk")) {
    return !!talker.trainMemberships?.length;
  }

  if (talker.organization?.subscriptionPlan?.slug === "wetalk") {
    return !!talker.trainMemberships?.length;
  }

  return true;
}
